module.exports = __webpack_public_path__ + "media/images/heimdall-d08c052023a8bb864c8ac57a0252b786.png";